import React from "react";

const CText = (props) => {
  const {
    className = "",
    containerClass = "",
    fontSize = "14px",
    text = "",
    onClick = () => null,
    style = {},
  } = props;

  return (
    <div className={`text-container ${containerClass}`}>
      <p
        style={{ fontSize: `${fontSize}`, ...style }}
        onClick={onClick}
        className={`c-text ${className} `}
      >
        {text}
      </p>
    </div>
  );
};
export default CText;
